<template>
  <div id="app">
    <Navigation :user="user" @logout="logout" />
    <router-view
      class="container"
      :user="user"
      :meetings="meetings"
      :errorMessage="errorMessage"
      @addMeeting="addMeeting"
      @checkIn="checkIn"
      @deleteMeeting="deleteMeeting"
      @logout="logout"
    />
  </div>
</template>

<script>
import Firebase from "@firebase/app";

// @ is an alias to /src
import db from "@/db.js";
import Navigation from "@/components/Navigation.vue";

export default {
  name: "App",
  data: function() {
    return {
      user: null,
      errorMessage: null,
      meetings: [],
      unsubscribe: null
    };
  },
  methods: {
    addMeeting: function(payload) {
      db.firestore()
        .collection("users")
        .doc(this.user.uid)
        .collection("meetings")
        .add({
          name: payload.name,
          date: payload.date,
          time: payload.time,
          place: payload.place,
          createdAt: Firebase.firestore.FieldValue.serverTimestamp()
        });
    },
    checkIn: function(payload) {
      // Verify meeting exists and is owned by the current user
      db.firestore()
        .collection("users")
        .doc(payload.userID)
        .collection("meetings")
        .doc(payload.meetingID)
        .get()
        .then(
          doc => {
            if (doc.exists) {
              db.firestore()
                .collection("users")
                .doc(payload.userID)
                .collection("meetings")
                .doc(payload.meetingID)
                .collection("attendees")
                .add({
                  displayName: payload.displayName,
                  eMail: payload.eMail,
                  createdAt: Firebase.firestore.FieldValue.serverTimestamp()
                })
                .then(() => {
                  this.$router.push(
                    "/attendees/" + payload.userID + "/" + payload.meetingID
                  );
                });
            } else {
              this.errorMessage = "Sorry, no such meeting";
            }
          },
          error => {
            this.errorMessage = error.message;
          }
        );
    },
    deleteMeeting: function(payload) {
      db.firestore()
        .collection("users")
        .doc(this.user.uid)
        .collection("meetings")
        .doc(payload)
        .delete();
    },
    logout: function() {
      // Unsubscribe from snapshot listener
      this.unsubscribe();
      // Now signout from firebase
      db.auth()
        .signOut()
        .then(
          () => {
            this.user = null;
            this.$router.push("/login");
          },
          error => {
            this.errorMessage = error.message;
          }
        );
    }
  },
  mounted() {
    db.auth().onAuthStateChanged(user => {
      if (user) {
        this.user = user;
        this.unsubscribe = db
          .firestore()
          .collection("users")
          .doc(this.user.uid)
          .collection("meetings")
          .onSnapshot(snapshot => {
            const tempData = [];
            snapshot.forEach(doc => {
              tempData.push({
                id: doc.id,
                name: doc.data().name,
                date: doc.data().date,
                time: doc.data().time,
                place: doc.data().place
              });
            });
            this.meetings = tempData.sort((a, b) => {
              // Case-insensitive sort by name
              if (a.name.toLowerCase() < b.name.toLowerCase()) {
                return -1;
              } else {
                return 1;
              }
            });
          });
      }
    });
  },
  components: {
    Navigation
  }
};
</script>

<style lang="scss">
$light: #c8ccde;
$primary: #708090;
$secondary: #1f1fcf;
@import "node_modules/bootstrap/scss/bootstrap";
</style>
